import React, { createContext, useContext, useEffect, useState } from 'react';

const GeneralRiskContext = createContext();

export const useGeneralRiskContext = () => {
    const context = useContext(GeneralRiskContext);

    if (!context) {
        throw new Error('useGeneralRiskContext must be used within a GeneralRiskContext');
    }

    return context;
};

export const GeneralRiskProvider = ({ children, fetchDashboardUrl }) => {
    const [loading, setLoading] = useState({ dashboard: true });
    const [dashboardData, setDashboardData] = useState({});

    useEffect(() => {
        fetchDashboard();
    }, []);

    const setLoadingState = (key, value) => {
        setLoading((state) => ({ ...state, [key]: value }));
    };

    const fetchDashboard = () => {
        setLoadingState('dashboard', true);

        axios
            .get(fetchDashboardUrl, { params: { scope: 'central' } })
            .then(({ data }) => {
                setDashboardData(data);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setLoadingState('dashboard', false));
    };

    const value = { fetchDashboard, dashboardData, loading };

    return <GeneralRiskContext.Provider value={value}>{children}</GeneralRiskContext.Provider>;
};

export default GeneralRiskContext;
